import { Select } from '@ngxs/store';
import { AppState } from 'app/store/store.state';
import { Observable } from 'rxjs';

export class FeatureCoreComponent {
  @Select(AppState.isProgressBarShowing)
  isLoading$: Observable<boolean>;

  pageSize = 10;
  pageSizeOptions: Array<number> = [10, 20, 50, 100];

  snackBarConfig = {
    duration: 30000,
  };

  fixCompetitorImageUrl(url): string {
    let rv = url;
    if (!url) {
      rv = `/assets/images/product-image-placeholder.png`;
    }

    return rv;
  }
}
